import store from "redux-share/store"
import { API, getAccessToken, getApiUrls } from "../services";
import { conditions, hasQuestionMark } from "helpers";
import { ConditionName, IDetailsConfig } from "interfaces";

export const detailAPI = (id?:number) => {
    const { getDetailsFromVoucher, params } = store.getState().videoData;
    return getDetailsFromVoucher ? API().voucherDetail() : getApiUrls().apiUrl + (id ? id : params.id);
  }

const detailsConfig:IDetailsConfig = {
    url: "",
    maxRetryCount: 0,
    headers: {},
    retryPolicy: []
}

const liveDetailsConfig = (userId?:number) => {
    detailsConfig.url = detailAPI(userId);
    let org: string = window.location.origin;
    org = org.replace("https://", "");
    org = org.replace("http://", "");
    detailsConfig.url += "?from=" + org;
}

const nonLiveDetailsConfig = () => {
    detailsConfig.url = detailAPI();
    detailsConfig.maxRetryCount = 3;
    detailsConfig.retryPolicy = [
        {
            codeAbove: 500,
            codeBelow: null,
            excludeCodes: [],
            includeCodes: [409],
            delay: 1,
            count: 3
        },
        {
            codeAbove: null,
            codeBelow: 404,
            excludeCodes: [403, 402, 401, 400],
            includeCodes: [],
            delay: 10,
            count: 6
        }
    ];
    return detailsConfig;
}

const hasIsAuthInParams = () => {
    const { token } = store.getState().videoData;
    if (hasQuestionMark(detailsConfig.url)) detailsConfig.url += `&token=${token}`;
    else detailsConfig.url += `?token=${token}`;
}

const hasHInParams = () => {
    detailsConfig.headers = {
        "authorization": `Bearer ${getAccessToken()}`
    }
}

const hasVoucherToken = () => {
    const { voucherToken } = store.getState().user;
    if(hasQuestionMark(detailsConfig.url)) detailsConfig.url += `&jwt=${voucherToken}`;
    else detailsConfig.url += `?jwt=${voucherToken}`;
}

const isCinemaHamrahEnvironment = () => {
    const { voucherToken } = store.getState().user;
    if(voucherToken) {
        if(hasQuestionMark(detailsConfig.url)) detailsConfig.url += `&jwt=${voucherToken}`;
        else detailsConfig.url += `?jwt=${voucherToken}`;
    }
}

export const handleDetailsConfig = (userId?:number) => {

    if(conditions(ConditionName.isLiveParam)) liveDetailsConfig(userId)
    else nonLiveDetailsConfig();

    if(conditions(ConditionName.isAuth)) hasIsAuthInParams();

    if (conditions(ConditionName.hasHParam)) hasHInParams();

    if(conditions(ConditionName.hasVoucherToken)) hasVoucherToken();

    if(conditions(ConditionName.isCinemaHamrahEnvironment)) isCinemaHamrahEnvironment();

    return detailsConfig;
} 